import { bankRecDateParams } from "@/views/BankReconciliation/BankRec/dates";
/* eslint-disable */
import React, { useEffect, useMemo, useState } from "react";
import { Modal, Button, Spin, message, Flex } from "antd";
import dayjs from "dayjs";
import http from "@/utils/http";
import api from "@/utils/api";
import EnhancedTable from "@/hocComponents/EnhancedTable";
import { EditOutlined } from "@ant-design/icons";
export default function BSModal({
  open,
  onClose,
  record,
  reconcileDateSt,
  onSuccess,
}) {
  const [loading, setLoading] = useState(false);
  const [sweepList, setSweepList] = useState([]);
  const [selectedBankIds, setSelectedBankIds] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [filters, setFilters] = useState({});
  const bankId = useMemo(
    () => record?.bankInfo?.bankId || record?.bankId,
    [record],
  );

  const trustId = useMemo(
    () => record?.bankInfo?.trustId || record?.trustId,
    [record],
  );

  const bankName = useMemo(
    () => record?.bankInfo?.name || record?.name,
    [record],
  );

  const glAcctByBank = useMemo(
    () => record?.bankInfo?.glAcct || record?.glAcct,
    [record],
  );

  const resetState = () => {
    setSweepList([]);
    setSelectedBankIds([]);
    setFilters({});
    setLoading(false);
    setSubmitLoading(false);
  };

  const loadData = async () => {
    if (!record || !bankId || !reconcileDateSt) return;

    setLoading(true);
    try {
      const params = { bankId, reconcileDateSt, bankName };
      const res = await http.get(api.getBaiSWeepList, { params: bankRecDateParams(params) });
      setSweepList(res?.data || []);
    } catch (e) {
      message.error(e?.message);
    } finally {
      setLoading(false);
    }
  };
  const fetchTableData = async (searchFilters = {}) => {
    if (!bankId || !reconcileDateSt || !bankName) return;

    setLoading(true);
    try {
      const params = {
        bankId,
        reconcileDateSt,
        bankName,
        ...searchFilters,
      };
      const res = await http.get(api.getBaiSWeepList, { params: bankRecDateParams(params) });
      setSweepList(res?.data || []);
    } catch (e) {
      message.error(e?.message);
    } finally {
      setLoading(false);
    }
  };
  // 搜索
  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  const handleFilterSubmit = (nextFilters) => {
   fetchTableData(nextFilters);
  };

  const handleSubmit = () => {
    if (!reconcileDateSt)
      return message.warning("Please select a clear date first.");
    if (!selectedBankIds || selectedBankIds.length === 0)
      return message.warning("Please select at least one transaction.");

    Modal.confirm({
      title: "Confirm Clear",
      content: "You are about to clear those transactions.",
      okText: "Confirm",
      cancelText: "Close",
      centered: true,
      onOk: doSubmit,
    });
  };

  const doSubmit = async () => {
    const params = {
      bankTransNewIds: selectedBankIds.join(","),
      trust: trustId,
      bank: bankId,
      glAcct: glAcctByBank,
    };

    setSubmitLoading(true);
    try {
      await http.get(api.getBaiSweepByClearTrans, { params: bankRecDateParams(params) });
      message.success("Cleared successfully.");
      await loadData();

      setSelectedBankIds([]);
      onSuccess?.();
    } catch (e) {
      message.error(e?.message || "Clear failed.");
    } finally {
      setSubmitLoading(false);
    }
  };

  useEffect(() => {
    if (open && record && reconcileDateSt) {
      setFilters({});
      fetchTableData({});
    }
    if (!open) {
      resetState();
    }
  }, [open, record, reconcileDateSt]);

  const clearedColumns = [
    // { title: "#", dataIndex: "#", width: 50 },
    {
      title: "Date",
      dataIndex: "date",
      filterKey: "date",
      filterType: "date",
       render: (value) => {
    if (!value) return " ";
    return dayjs(value).format("MM/DD/YYYY");
  },
    },
    {
      title: "Check #",
      dataIndex: "checkNo",
      filterKey: "checkNo",
      filterType: "input",
    },
    {
      title: "Amount",
      dataIndex: "amountRow",
      filterKey: "amountRow",
      filterType: "input",
    },
    {
      title: "Journal",
      dataIndex: "journal",
      filterKey: "journal",
      filterType: "input",
    },
    {
      title: "BAI Code",
      dataIndex: "baiCode",
      filterKey: "baiCode",
      filterType: "input",
    },
   {
  title: "Cleared Date",
  dataIndex: "clearedDate",
  filterKey: "clearedDate",
  filterType: "date",
  render: (value) => {
    if (!value) return " ";
    return dayjs(value).format("MM/DD/YYYY");
  },
},
    {
      title: "Description",
      dataIndex: "remark",
      filterKey: "remark",
      filterType: "input",
    },
  ];



  return (
    <Modal
      width="80%"
      open={open}
      maskClosable={false}
      onCancel={onClose}
      afterClose={resetState}
      footer={
         <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
        <Button key="close" danger onClick={onClose}>
          Close
        </Button>
      </div>
      }
      title={
        <div style={{ fontSize: 18, fontWeight: "bold", color: "#E55353" }}>
          <EditOutlined style={{ marginRight: 10 }} />
          VIEWING BANK TRANSACTIONS FOR TRUST: {record?.bankInfo?.trust} | BANK:{" "}
          {record?.bankInfo?.bank} | GL: {record?.bankInfo?.glAcct} | CR:{" "}
          {record?.bankInfo?.crAcct} | CP: {record?.bankInfo?.cpAcct} | CLEAR
          DATE:{" "}
          {reconcileDateSt ? dayjs(reconcileDateSt).format("MM/DD/YYYY") : ""}
        </div>
      }
    >
      <Flex justify="space-between" align="flex-start">
        <div style={{ width: "100%" }} className="model_top">
        
            <div style={{ marginTop: 10 }}>
              <Button
                type="primary"
                onClick={handleSubmit}
                loading={submitLoading}
                style={{ marginBottom: 10 }}
              >
                Clear Trans
                <span style={{ color: "#fff", marginRight: 10 }}>
                  {selectedBankIds?.length || 0}
                </span>
              </Button>
            </div>
            <EnhancedTable
              rowKey="bankTransNewId"
              loading={loading}
              columns={clearedColumns}
              dataSource={sweepList}
              scroll={{ y: "calc(100vh - 350px)" }}
              filters={filters}
              onFilterChange={handleFilterChange}
              onFilterSubmit={handleFilterSubmit}
              rowSelection={{
                selectedRowKeys: selectedBankIds,
                onChange: (keys) => setSelectedBankIds(keys),
                preserveSelectedRowKeys: true,
              }}
            />
       
        </div>
      </Flex>
    </Modal>
  );
}
